import { ORCHESTRATION_SERVICE_API } from '../constants/AppConstants';

/**
 * Public sitemap image fetch — never send credentials/Authorization.
 * @param {string} encryptedReportId
 * @returns {Promise<{ok: boolean, imageUrl?: string, blob?: Blob, status?: number, error?: string, json?: object}>}
 */
const getSitemapImageService = async (encryptedReportId) => {
  try {
    const response = await fetch(
      `${ORCHESTRATION_SERVICE_API}/v1/sitemap/image/${encodeURIComponent(encryptedReportId)}`,
      {
        method: 'GET',
        credentials: 'omit',
        skipAuthHeader: true,
        headers: {
          Accept: 'image/jpeg, */*',
        },
      },
    );

    if (response.status !== 200) {
      const json = await response.json().catch(() => null);
      return {
        ok: false,
        status: response.status,
        json,
        error: json?.errorDescription || 'Failed to fetch sitemap image',
      };
    }

    const blob = await response.blob();
    const imageUrl = URL.createObjectURL(blob);

    return { ok: true, imageUrl, blob };
  } catch (error) {
    return { ok: false, error: error.message };
  }
};

export default getSitemapImageService;
